"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var injectScript = function injectScript(script) {
    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
};

exports["default"] = injectScript;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/piwik-wrap/build/lib/injectScript.js
 ** module id = ./node_modules/piwik-wrap/build/lib/injectScript.js
 ** module chunks = 1
 **/